<div class="title">
    <span *ngIf="start?.dynList?.dynForm?.formResult?.title; else defaultTitle">
        {{start?.dynList?.dynForm?.formResult?.title}}</span>
    <ng-template #defaultTitle>
        <span>New Task</span>
    </ng-template>
    <mat-icon class="close-button" (click)="close()">close</mat-icon>
</div>
<app-start #start directory="/public/HR" [data]="data" (isSubmitted)="onSubmit($event)" (isCanceled)="close()">
</app-start>